// apps/web/src/features/dashboards/china-requests/StatusFunnel.tsx (#1589, #2166)
// Status funnel, one stage per status in fixed lifecycle order, rendered via the
// shared `FunnelView` primitive (#2163). ARCHIVE is never shown (excluded by the
// contract and absent from the order array).
import type { ChinaRequestsDashboardSummary } from '@magimp/shared';
import { FunnelView } from '../../../ui/index.js';
import { FUNNEL_STATUS_ORDER, STATUS_LABEL_KEYS } from './labels.js';
import { SECTION_CARD, type DashboardT } from './section.js';

interface StatusFunnelProps {
  funnel: ChinaRequestsDashboardSummary['funnel'];
  t: DashboardT;
}

export function StatusFunnel({ funnel, t }: StatusFunnelProps) {
  const countByStatus = new Map(funnel.map((entry) => [entry.status, entry.count]));
  const stages = FUNNEL_STATUS_ORDER.map((status) => ({
    key: String(status),
    label: t(`requests:${STATUS_LABEL_KEYS[status]}`),
    value: countByStatus.get(status) ?? 0,
  }));

  return (
    <section style={{ ...SECTION_CARD, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontSize: 13, fontWeight: 600 }}>
        {t('dashboards:chinaRequests.funnel.title')}
      </div>
      <div data-testid="china-requests-funnel">
        <FunnelView
          stages={stages}
          ariaLabel={t('dashboards:chinaRequests.funnel.title')}
          labelHeader={t('dashboards:chinaRequests.funnel.statusHeader')}
          valueHeader={t('dashboards:chinaRequests.funnel.countHeader')}
        />
      </div>
    </section>
  );
}
